const EMPTY_RESULT_TOKENS = new Set([
  'null',
  'undefined',
  'none',
  'n/a',
  'na',
  'nan',
  '[object object]'
])

export function isEmptyLotteryResultToken(value) {
  if (value === undefined || value === null) return true
  if (typeof value !== 'string') return false
  const text = value.trim()
  return !text || EMPTY_RESULT_TOKENS.has(text.toLowerCase())
}

export function safeLotteryResultText(value) {
  return isEmptyLotteryResultToken(value) ? '' : String(value).trim()
}

export function splitLotteryResult(value, options = {}) {
  if (isEmptyLotteryResultToken(value)) return []
  if (Array.isArray(value)) {
    return value.map(safeLotteryResultText).filter(Boolean)
  }
  if (typeof value === 'object') return []

  const text = safeLotteryResultText(value)
  if (!text) return []
  if (text.startsWith('{')) return []
  if (text.startsWith('[')) {
    try {
      return splitLotteryResult(JSON.parse(text), options)
    } catch (e) {
      return []
    }
  }

  if (options.extractNumbers) {
    const numbers = text.match(/\d+/g)
    if (numbers) return numbers
  }

  return text
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item && !isEmptyLotteryResultToken(item))
}

export function parseLotteryResult(value) {
  if (isEmptyLotteryResultToken(value)) return {}
  if (Array.isArray(value)) return { winning: splitLotteryResult(value) }
  if (typeof value === 'object') return value || {}

  const text = safeLotteryResultText(value)
  if (!text) return {}

  try {
    const parsed = JSON.parse(text)
    if (isEmptyLotteryResultToken(parsed)) return {}
    if (Array.isArray(parsed)) return { winning: splitLotteryResult(parsed) }
    if (parsed && typeof parsed === 'object') return parsed
    return { winning: safeLotteryResultText(parsed) }
  } catch (e) {
    return { winning: text }
  }
}

export function lotteryResultTokens(value, key = 'winning', options = {}) {
  const result = parseLotteryResult(value)
  if (result && typeof result === 'object' && result[key] !== undefined) {
    return splitLotteryResult(result[key], options)
  }
  const text = safeLotteryResultText(value)
  if (
    text.startsWith('{') ||
    text.startsWith('[') ||
    (text.startsWith('"') && text.endsWith('"'))
  ) {
    return []
  }
  return splitLotteryResult(value, options)
}

export function formatLotteryDrawTime(raw, dayjs, fallback = '--') {
  const text = safeLotteryResultText(raw)
  if (!text) return fallback
  const value = typeof dayjs === 'function' ? dayjs(text) : null
  return value && value.isValid && value.isValid()
    ? value.format('DD/MM/YYYY HH:mm:ss')
    : text
}
